import { IonButton, IonContent, IonHeader, IonImg, IonPage, IonToolbar } from '@ionic/react';
import React, { useEffect, useState } from 'react';

const TermsPage: React.FC = () => {
  // The policy content is a large (~390KB) static HTML snapshot, so it is
  // code-split and loaded only when this page is opened to keep it out of the
  // main bundle. It is inlined via srcDoc (not an external iframe/script)
  // because the deployment CSP allows neither app.termly.io nor a same-origin
  // child frame — only inline srcDoc content renders.
  const [html, setHtml] = useState<string>('');

  useEffect(() => {
    let active = true;
    void import('./privacy-terms').then((mod) => {
      if (active) {
        setHtml(mod.privacyHtml);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <IonPage>
      <div className="slotcheck-header">
        <IonHeader className="small-header header-dark">
          <IonToolbar>
            <IonButton
              fill="clear"
              onClick={() => {
                history.back();
              }}
              className="icon-back"
              slot="start"
            >
              <IonImg src="assets/images/back-icon.svg" />
            </IonButton>
            <div className="logo header-title">Terms and Conditions</div>
          </IonToolbar>
        </IonHeader>
      </div>
      <IonContent className="terms">
        <iframe
          title="Terms and Conditions"
          srcDoc={html}
          referrerPolicy="same-origin"
          width="100%"
          height="100%"
          frameBorder="0"
          className="responsive-iframe"
          style={{ colorScheme: 'light', background: '#ffffff' }}
        ></iframe>
      </IonContent>
    </IonPage>
  );
};

export default TermsPage;
